import React, { useEffect, useCallback } from "react";
import { selectors } from "@ReduxStore/reducers";
import { useSelector } from "react-redux";

import "./FiveNine.scss";

function FiveNineComponent() {
  const scriptId = "fiveninescript";
  const member = useSelector(selectors.getMember);
  const program = useSelector(selectors.getProgram);
  const [chatLoaded, setChatLoaded] = React.useState(
    Boolean(document.querySelector(`#${scriptId}`)),
  );

  const updateChat = useCallback(
    function (member) {
      const memberName = member.first_name ? `${member.first_name} ${member.last_name}` : "";
      const memberCid = member.member_key || "";
      const profile =
        process.env.REACT_APP_ENV === "production" ? "Chat Campaign" : "Chat Campaign_stage";
      let options = {
        rootUrl: "https://app.five9.com/consoles/",
        type: "chat",
        title: "Chat with us",
        tenant: "Access Development",
        profiles: profile,
        showProfiles: false,
        autostart: true,
        theme: "high-contrast.css",
        surveyOptions: {
          showComment: true,
          requireComment: false,
        },
        fields: {
          name: {
            value: memberName,
            show: true,
            label: "Member Name",
          },
          email: {
            value: member.email || "",
            show: true,
            label: "Member Email",
          },
          mcid: {
            value: memberCid,
            show: false,
            label: "Member CID",
          },
          programName: {
            value: program.name,
            show: false,
            label: "Program Name",
          },
          pcid: {
            value: program.key,
            show: false,
            label: "Program CID",
          },
          helpNumber: {
            value: program.help_phone_number,
            show: false,
            label: "Program Help Number",
          },
          programUrl: {
            value: window.location.host,
            show: false,
            label: "Program URL",
          },
        },
        playSoundOnMessage: true,
        allowCustomerToControlSoundPlay: false,
        showEmailButton: true,
        hideDuringAfterHours: true,
        useBusinessHours: false,
        showPrintButton: false,
        allowUsabilityMenu: false,
        enableCallback: false,
        callbackList: "",
        allowRequestLiveAgent: false,
      };
      window.Five9SocialWidget.addWidget(options);
      window.Five9SocialWidget.options.fields = options.fields;
      setChatLoaded(true);
    },
    [program],
  );

  useEffect(() => {
    if (!Boolean(document.querySelector(`#${scriptId}`))) {
      let a = document.createElement("script");
      a.id = scriptId;
      a.type = "text/javascript";
      a.async = !0;
      a.src = "https://app.five9.com/consoles/SocialWidget/five9-social-widget.min.js";
      let n = document.getElementsByTagName("script")[0];
      n.parentNode.insertBefore(a, n);
      setTimeout(() => setChatLoaded(true), 1000);
    }
  });

  useEffect(() => {
    if (chatLoaded && Boolean(window.Five9SocialWidget)) {
      updateChat(member);
    }
  }, [member, chatLoaded, updateChat]);

  return <></>;
}

export default FiveNineComponent;
